import React from "react";
import "./GroupSection.css";
import { useTranslation } from "react-i18next";

import ONeTicketLogo from "./logo/oneticket.png";
import AcegoodLogo from "./logo/acegood.png";
import AcefundLogo from "./logo/acefund.png";

const GroupSection = () => {
  const { t } = useTranslation();

  const subsidiaries = [
    {
      id: "oneticket",
      img: ONeTicketLogo,
      description: t("group.oneticket_desc"),
      link: "https://one-ticket.be",
      color: "#8e44ad",
    },
    {
      id: "acefund",
      img: AcefundLogo,
      description: t("group.acefund_desc"),
      link: "https://acefund.io",
      color: "#00f0ff",
    },
  ];

  return (
    <section className="group-section-wrapper">
      <div>
        <div>
          <h1 className="groupSection">{t("group.title")}</h1>
        </div>
        <div className="tree-container">
          {/* --- NIVEAU 1 : PARENT (ACEGOOD) --- */}
          <div className="tree-level-1">
            <div className="org-card parent-card">
              <img
                src={AcegoodLogo}
                alt="Acegood Logo"
                className="acegood-main-logo"
              />
              <p className="org-description">{t("group.desc")}</p>
            </div>
          </div>
          {/* --- NIVEAU 2 : ENFANTS --- */}
          <ul className="tree-level-2">
            {subsidiaries.map((company) => (
              <li key={company.id} className="tree-branch">
                <a
                  href={company.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="org-card child-card"
                  style={{ borderTopColor: company.color }}
                >
                  <div className="card-header">
                    <div className="logo-container">
                      <img
                        src={company.img}
                        alt={`${company.id} logo`}
                        className="child-logo"
                      />
                    </div>
                  </div>
                  <p>{company.description}</p>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default GroupSection;
